import React from "react"
import {useTranslation} from "react-i18next"
import {DocumentArrowDownIcon} from "@heroicons/react/24/outline"

import {ButtonLoading} from "../../../components/Button"
import {useDownloadAssignmentProspectsMutation} from "../../../queries/prospects"
import requestError from "../../../services/requestError"

export const DownloadProspectsListButton: React.FC<{assignmentId: number}> = ({assignmentId}) => {
  const {t} = useTranslation()

  const mutation = useDownloadAssignmentProspectsMutation()

  const handleClick = async () => {
    try {
      const response = await mutation.mutateAsync(assignmentId)
      const url = response.data.prospect_export_url
      if (url) {
        window.location.href = url
      }
    } catch (e) {
      requestError(e)
    }
  }

  return (
    <ButtonLoading
      variant={"outlined"}
      color={"blue"}
      iconLeft={<DocumentArrowDownIcon className={"size-5"} />}
      onClick={handleClick}
    >
      {t("Prospects_DownloadProspectsListButton")}
    </ButtonLoading>
  )
}
